export default "__VITE_ASSET__CmNa5NSG__"